import ChannelPlugin from '@/plugin/ChannelPlugin'

const plugin = {}

plugin.install = function(Vue) {
  Vue.ChannelPlugin = ChannelPlugin.callApiChannel()
}

export default plugin
